const ITEMS = [
  "Every Child Deserves to Be Heard",
  "Screen · Support · Report",
  "RCI Registered · A58697",
  "In-School Therapy",
  "Small Steps, Big Progress",
  "Supporting Communication",
  "Building Brighter Futures",
];

export const Marquee = () => {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div
      data-testid="manifesto-marquee"
      className="overflow-hidden border-y border-pine-900/10 bg-sand py-5"
    >
      <div className="flex w-max animate-marquee items-center gap-10 whitespace-nowrap">
        {row.map((item, i) => (
          <span key={i} className="flex items-center gap-10">
            <span className="font-serif text-lg italic text-pine-900/80 sm:text-xl">{item}</span>
            <span className="text-clay">✳</span>
          </span>
        ))}
      </div>
    </div>
  );
};
